import React from 'react';
import {
    Popup,
    EditableComponent,
    InputField,
} from 'arteia-js/components';

import _ from 'lodash';

import { API } from 'arteia-js/services';
import queryString from 'query-string';

class TwoFactorCode extends EditableComponent {
    state = {
        code: '',
        errorMessage: '',
    };

    componentDidMount() {
        const { history } = this.props;
        const { state } = history.location;


        if (!state || !state.twoFactorId) {
            return history.push('/login');
        }
        return _.noop();
    }

    errorMessages = {
        503: 'Service unavailable',
        500: 'Ooops, something went wrong',
        403: 'Unauthorized',
        400: 'Bad request',
        404: 'Two Factor failed. Please try again.',
        421: 'Wrong code',
    };

    allowSave = () => this.state.code.length > 0;

    confirmCode = () => {
        const { history } = this.props;
        const { twoFactorId, returnTo = 'client' } = history.location.state;

        const { code } = this.state;

        return API.post('/login/confirm', { twoFactorId, code }).then((response) => {
            const { token, secureUrl } = response;
            const query = { token, returnTo };

            window.location.assign(`${secureUrl}/redirect?${queryString.stringify(query)}`);
        }).catch((err) => {
            if (err.status === 404) {
                return history.push('/login', { errorMessage: this.errorMessages[err.status] });
            }
            return this.setState({
                errorMessage: this.errorMessages[err.status],
            });
        });
    };


    handleKeyPress = (e) => {
        const { code } = this.state;
        if (e.key === 'Enter' && code.length > 0) {
            this.confirmCode();
        }
    };

    render() {
        const { code, errorMessage = '' } = this.state;

        return (
            <Popup size='form' noTitle
                noCloseHandler
                className="form">
                <div className="popup-content">

                    <InputField
                        value={code}
                        onChange={this.onFieldChange('code')}
                        label={'Verification code'}
                        handleKeyPress={this.handleKeyPress}
                    />

                    <div className="form-msg">
                        <span className="error-msg">{errorMessage.length !== 0 && errorMessage}</span>
                    </div>

                    <button className="art-btn" disabled={!this.allowSave()} onClick={this.confirmCode}>
                        Confirm
                    </button>
                </div>


            </Popup>
        );
    }
}

TwoFactorCode.propTypes = {};
TwoFactorCode.defaultProps = {};

export default TwoFactorCode;



// WEBPACK FOOTER //
// ./src/scenes/TwoFactorCode/index.js